import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row } from 'react-bootstrap';
import Tabs from './Tabs';

const tabsData = [
  {
    name: 'Address',
    content: <div>Address</div>,
    leftIcon: <FontAwesomeIcon icon={light('map-location-dot')} />,
  },
  {
    name: 'Email',
    content: <div>Email</div>,
    rightIcon: <FontAwesomeIcon icon={light('at')} />,
  },
  {
    name: 'Phone',
    content: <div>Phone</div>,
  },
  {
    name: 'Communication',
    content: <div>Communication</div>,
  },
  {
    name: 'Banking',
    content: <div>Banking</div>,
  },
  {
    name: 'Beneficiaries',
    content: <div>Beneficiaries</div>,
  },
  {
    name: 'Family Members',
    content: <div>Family Members</div>,
  },
  {
    name: 'Login & Recovery',
    content: <div>Login & Recovery</div>,
  },
];

const TabsDemo = () => {
  return (
    <Container>
      <Container className="mt-10">
        <h4>Tabs Component</h4>
        <Row>
          <Tabs tabs={tabsData} />
        </Row>
      </Container>
    </Container>
  );
};

export default TabsDemo;
